import * as React from "react";
import Component from "../../AbstractComponent";
import Constants from "../../../Action/Constants";
import { connect } from "react-redux";
import { MiddlewareInterface } from "../../../Middleware/MiddlewareInterface";
import SettingsUpdateWillMount from "../../../Middleware/Middlewares/SettingsUpdateWillMount";

import UserProfile from "./UserProfile";
import AgencyProfile from "./AgencyProfile";
import BankAccounts from "./BankAccounts";
import EmailAccounts from "./EmailAccounts";
import ActivityTemplates from "./ActivityTemplates";
import Users from "./Users";
import ChargeTypes from "./ChargeTypes";

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Button from '@material-ui/core/Button';

class Settings extends Component {
  public state = {
    selectedTabIndex: 0,
    agencySettings: null
  };

  protected shouldClearBeforeUnmounting: boolean = true;
  protected clearWith: string = Constants.PAGE_SETTINGS_USER_PROFILE_CLEAR;
  protected middlewares: MiddlewareInterface[] = [
    SettingsUpdateWillMount
  ];

  constructor(public props) {
    super(props);
  }

  public switchTab = (_event, tabValue) => {
    this.setState({
      selectedTabIndex: tabValue
    });

    this.props.dispatch({
      type: Constants.PAGE_SETTINGS_UPDATE_SWITCH_TAB,
      payload: {
        index: tabValue
      }
    });
  }

  public render() {
    const beta = this.props && this.props.app && this.props.app.settings && this.props.app.settings.user && this.props.app.settings.user.beta ? this.props.app.settings.user.beta : false;

    return (
      <div className="state-app">
        <div className="box box-full component-settings full-width has-general-page-header">
          <div className="component-header no-paddings">
            <div style={{display: "flex", justifyContent: "space-between",width: "calc(98vw - 125px)", padding: "0 40px"}}>
              <h1 style={{padding: "24px 0"}}>{this.trans("title-settings")}</h1>
              <div className="button-container">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.redirectBack}
                >
                  {this.trans("button-close")}
                </Button>
              </div>
            </div>
          </div>

          <div className="component-wrapper no-margin-top no-shadow settings-content" style={{display: "flex"}}>
            <Tabs
              className="tab settings-tabs tab-simple light-tabs"
              orientation="vertical"
              onChange={this.switchTab}
              value={this.state.selectedTabIndex}
            >
              <Tab
                value={0}
                label={this.trans("settings-user-profile")}
              />

              <Tab
                value={1}
                label={this.trans("settings-agency-profile")}
              />

              <Tab
                value={2}
                label={this.trans("bank-accounts")}
              />

              {
                beta &&
                <Tab
                  value={3}
                  label={this.trans("mail")}
                />
              }

              <Tab
                value={4}
                label={this.trans("activity-templates")}
              />

              <Tab
                value={5}
                label={this.trans("title-users")}
              />

              <Tab
                value={6}
                label={this.trans("page/settings-tab/chargetypes-label")}
              />
            </Tabs>

            {this.state.selectedTabIndex === 0 && <UserProfile {...this.props} />}
            {this.state.selectedTabIndex === 1 && 
              <AgencyProfile
                {...this.props}
                agencySettings={this.state.agencySettings} 
              />
            }
            {this.state.selectedTabIndex === 2 && <BankAccounts {...this.props} />}
            {this.state.selectedTabIndex === 3 && beta && <EmailAccounts {...this.props} />}
            {this.state.selectedTabIndex === 4 && <ActivityTemplates {...this.props} />}
            {this.state.selectedTabIndex === 5 && <Users {...this.props} />}
            {this.state.selectedTabIndex === 6 && <ChargeTypes {...this.props} />}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps)(
  Settings
);
